export default "__VITE_ASSET__DcoOUhlJ__"